var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesCv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D5D7D1",
    d: "M56.375 9.871L20.178 9.871 20.178 73.583 65.967 73.583 65.967 19.463 56.375 9.871",
    transform: "translate(-444 -2226) translate(444 2226)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B6B8B4",
    d: "M56.375 19.463L65.967 19.463 56.375 9.871 56.375 19.463",
    transform: "translate(-444 -2226) translate(444 2226)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#48525B",
    d: "M27.13 20.695L48.279 20.695 48.279 18.231 27.13 18.231zM38.071 28.292L58.956 28.292 58.956 25.799 38.071 25.799zM27.13 28.292L32.762 28.292 32.762 25.799 27.13 25.799zM46.167 35.86L56.375 35.86 56.375 33.367 46.167 33.367zM27.13 35.86L40.828 35.86 40.828 33.367 27.13 33.367zM51.007 58.593L58.956 58.593 58.956 56.1 51.007 56.1zM27.13 58.593L45.698 58.593 45.698 56.1 27.13 56.1zM27.13 66.161L34.316 66.161 34.316 63.668 27.13 63.668zM39.626 66.161L52.004 66.161 52.004 63.668 39.626 63.668z",
    transform: "translate(-444 -2226) translate(444 2226)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6E8188",
    d: "M17.45 43.193l-6.248 2.875 6.248 2.845c.909-1.877.909-3.842 0-5.72",
    transform: "translate(-444 -2226) translate(444 2226)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B6B8B4",
    d: "M23.58 40.377l-6.13 2.816c.909 1.878.909 3.843 0 5.72l6.13 2.816c1.878-3.696 1.878-7.656 0-11.352",
    transform: "translate(-444 -2226) translate(444 2226)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5726C",
    d: "M73.506 40.377h-5.163c1.877 3.696 1.877 7.656 0 11.352h5.163c1.877-3.696 1.877-7.656 0-11.352",
    transform: "translate(-444 -2226) translate(444 2226)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8D481",
    d: "M68.343 40.377H23.58c.939 1.878 1.408 3.755 1.408 5.691h44.763c0-1.936-.47-3.813-1.408-5.69",
    transform: "translate(-444 -2226) translate(444 2226)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3B26A",
    d: "M24.988 46.068c0 1.907-.469 3.784-1.408 5.661h44.763c.939-1.877 1.408-3.754 1.408-5.661H24.988",
    transform: "translate(-444 -2226) translate(444 2226)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesCv);
export default __webpack_public_path__ + "static/media/features-cv.57a53704.svg";
export { ForwardRef as ReactComponent };